import React from 'react'

const Product = () => {
  return (
    <div>Analytic</div>
  )
}

export default Product